<div *ngIf="!showLoadingComp" class="container-fluid">
  <div class="hero-image">
    <app-cfet-carousel></app-cfet-carousel>
    <div class="overlay-container">
      <div class="header-content">
        <header>{{cfetLabels.cfet_customer_landing.header_content}}</header>
      </div>

      <div class="eligibility-button">
        <button type="button" class="btn"
          (click)="eligibility()">{{cfetLabels.cfet_customer_landing.check_eligibility}}</button>
      </div>

      <div class="affiliation-code-div" *ngIf="!enableAffiliation">
        <a class="affiliation-link" (click)="affiliationenable()" (keyup)="affiliationenable()">
          {{cfetLabels.cfet_customer_landing.affiliation_or_association}}
        </a>
      </div>

      <div class="form-group" *ngIf="enableAffiliation">
        <form [formGroup]="affCodeForm" (ngSubmit)="onSubmitAffCode($event)">
          <div class="label">
            <label for="affiliation"
              id="affiliation-label">{{cfetLabels.cfet_customer_landing.enter_affiliation_or_association}}</label>
          </div>
          <div>
            <input type="text" aria-label="enter affliation code" class="form-control" id="affiliation"
              formControlName="affCode" (keydown)="onSubmitAffCode($event)">
            <span class="back-icon" style="margin-left: -7%;cursor: pointer;" tabindex="0"
              (click)="onSubmitAffCode($event)" (keydown)="onSubmitAffCode($event)">
              <img alt="Rectangle image" src="assets/images/Rectangle 4.jpg">
              <em id="arrow" class="icon-arrows-skip-back1L" aria-label="search affliationcode"></em>
            </span>
          </div>
        </form>
      </div>
    </div>
  </div>
  <app-cfet-footer></app-cfet-footer>
</div>
<div [ngClass]="(showBadCodePopUp === true) ? 'bad-code-modal' : ''" class="container-fluid">
  <app-bad-code-modal [openModal]="openBadCodePopUp" (modalCloseEvent)="closeBadCodeModal($event)">
  </app-bad-code-modal>
</div>
<app-custom-spinner *ngIf="showLoadingComp"></app-custom-spinner>